import LogoWhite from '../assets/images/logo_white.svg';
import LogoDark from '../assets/images/logo_dark.svg';
import FavIcon from '../assets/images/icon.ico';

export const siteConfig = {
  name: '2Connect Professional',
  description: '2Connect Professional is an AI-powered networking platform that matches founders, investors, and professionals with the right counterparts based on goal complementarity.',
  url: 'https://app.2connect.ai',
  logo: LogoWhite,
  logoDark: LogoDark,
  favIcon: FavIcon,
  icon: 'https://app.2connect.ai/icon.png',
  keywords: ['2Connect Professional', '2Connect', 'professional networking', 'AI matching', 'reciprocity', 'founders', 'investors'],
  author: '2Connect Professional',
  twitter: 'https://twitter.com/',
  facebook: 'https://facebook.com/',
  instagram: 'https://instagram.com/',
  linkedin: 'https://linkedin.com/',
};
